exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-178ab312]{margin-top:16px;color:#454545;font-size:14px;line-height:25px;padding-right:16px}.text span[data-v-178ab312]{margin-top:8px;display:block}.result[data-v-178ab312]{display:flex}.container[data-v-178ab312]{width:895px}.btn[data-v-178ab312]{margin:0}.btn-group[data-v-178ab312]{margin-top:24px;justify-content:space-around}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-178ab312","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/assistance_steps/DataSent.vue
// module id = 216
// module chunks = 0